(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__ccInit) return;
  window.__ccInit = true;
  function init(root){
    if(root.__cc) return;
    root.__cc = true;
    var track = root.querySelector('.cc__track');
    if(!track) return;
    var prev = root.querySelector('.cc__prev');
    var next = root.querySelector('.cc__next');
    var dotsEl = root.querySelector('.cc__dots');
    var dots = [];
    function step(){
      var c = track.querySelector('.cc__card');
      if(!c) return track.clientWidth;
      var g = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c.getBoundingClientRect().width + g;
    }
    function pv(){ return Math.max(1, Math.round(track.clientWidth / step())); }
    function build(){
      if(!dotsEl) return;
      var n = track.querySelectorAll('.cc__card').length;
      var count = Math.max(1, n - pv() + 1);
      dotsEl.innerHTML = '';
      dots = [];
      for(var i = 0; i < count; i++){
        (function(i){
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function(){ track.scrollTo({left: i * step(), behavior: 'smooth'}); });
          dotsEl.appendChild(b);
          dots.push(b);
        })(i);
      }
    }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 2;
      var x = track.scrollLeft;
      if(prev) prev.disabled = x <= 2;
      if(next) next.disabled = x >= max;
      var idx = x >= max ? dots.length - 1 : Math.min(Math.round(x / step()), dots.length - 1);
      dots.forEach(function(d, i){
        if(i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function place(){
      var img = root.querySelector('.cc__img');
      var wrap = root.querySelector('.cc__wrap');
      if(!img || !wrap) return;
      var r = img.getBoundingClientRect();
      var w = wrap.getBoundingClientRect();
      root.style.setProperty('--cc-arrow-top', (r.top - w.top + r.height / 2) + 'px');
    }
    function layout(){ build(); place(); update(); }
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left: -step() * pv(), behavior: 'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left: step() * pv(), behavior: 'smooth'}); });
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, {passive: true});
    window.addEventListener('resize', layout);
    if('ResizeObserver' in window) new ResizeObserver(layout).observe(track);
    layout();
  }
  function all(ctx){ (ctx || document).querySelectorAll('[data-cc]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ all(); }); else all();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest ? e.target.closest('[data-pdp-share]') : null;
  if (!b) return;
  var url = b.getAttribute('data-share-url');
  var title = b.getAttribute('data-share-title');
  if (navigator.share) {
    navigator.share({ title: title, url: url }).catch(function () {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(function () {
      var s = b.querySelector('span');
      if (!s) return;
      var t = s.textContent;
      s.textContent = b.getAttribute('data-copied') || 'Link copied';
      setTimeout(function () { s.textContent = t; }, 2000);
    });
  }
});

(function () {
  function setup() {
    document.querySelectorAll('.pdp-styled .product__slides').forEach(function (s) {
      if (s.getAttribute('data-pdp-counter')) return;
      var slides = s.querySelectorAll('.product__slide');
      if (slides.length < 2) return;
      s.setAttribute('data-pdp-counter', '1');
      var c = document.createElement('div');
      c.className = 'pdp-counter';
      c.setAttribute('aria-hidden', 'true');
      s.appendChild(c);
      var update = function () {
        var idx = 0;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-selected')) { idx = i; break; }
        }
        c.textContent = (idx + 1) + '/' + slides.length;
      };
      new MutationObserver(update).observe(s, { subtree: true, attributes: true, attributeFilter: ['class'] });
      update();
    });
  }
  function start() { setup(); setTimeout(setup, 600); setTimeout(setup, 1800); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
